module.exports = __webpack_public_path__ + "static/6-19f463439cf04f68bd434acb4014098e.jpg";